import { render } from "./cardProfileModal.vue?vue&type=template&id=b06fc3da&scoped=true"
import script from "./cardProfileModal.vue?vue&type=script&lang=js"
export * from "./cardProfileModal.vue?vue&type=script&lang=js"

import "./cardProfileModal.vue?vue&type=style&index=0&id=b06fc3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06fc3da"]])

export default __exports__